"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importStar(require("react"));
const Theme_1 = __importStar(require("../../Theme/Theme"));
const index_1 = require("../../Utilities/index");
const StyledButton = Theme_1.styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.width || 'auto'};
  height: ${(props) => props.height};
  border-radius: ${(props) => (props.isRounded ? '20px' : '4px')};
  border: ${(props) => props.buttonStyle === 'outlined' ? `2px solid` : 'none'};
  font-family: ${(props) => props.theme.font.family.proximaNova};
  padding: 0 16px;
  box-shadow: ${(props) => props.hasDropShadow
    ? '0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2)'
    : 'none'};
  background-color: ${(props) => props.buttonStyle === 'solid' && props.disabled
    ? props.theme.gray3
    : props.buttonStyle !== 'solid'
        ? props.theme.white
        : Reflect.get(props.theme, props.color || 'blue') || props.theme['blue']};
  color: ${(props) => props.buttonStyle !== 'solid' && props.disabled
    ? props.theme.gray3
    : props.buttonStyle === 'solid'
        ? props.theme.white
        : Reflect.get(props.theme, props.color || 'blue') || props.theme['blue']};
  letter-spacing: 0.5px;
  &:focus {
    outline: 0;
  }
  &:hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    background-color: ${(props) => !props.disabled && getHoverColor(props.buttonStyle, props.color)};
  }
  > * {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }
`;
const TextContainer = Theme_1.styled.span `
  ${(props) => getCasing(props.textTransform)}
`;
function getHoverColor(buttonStyle = 'solid', color = 'blue') {
    const validColor = Reflect.get(Theme_1.default, color) || 'blue';
    if (buttonStyle === 'solid') {
        switch (color) {
            case 'blue':
                return '#005C95';
            default:
                return (0, index_1.lightenDarkenColor)(validColor, -0.25);
        }
    }
    else {
        switch (color) {
            case 'blue':
                return '#EAF7FF';
            case 'red':
                return '#FFF0F0';
            case 'orange':
                return '#FFF0D8';
            default:
                return (0, index_1.lightenDarkenColor)(validColor, 0.25);
        }
    }
}
function getCasing(textTransform) {
    if (textTransform === 'sentenceCase')
        return `text-transform: lowercase;
    &:first-letter {
      text-transform: uppercase;
    }`;
    else
        return `text-transform: ${textTransform}`;
}
const Button = (props) => {
    const hasChildren = !!react_1.Children.count(props.children);
    return (react_1.default.createElement(StyledButton
    // Styling for icon only buttons
    , Object.assign({ 
        // Styling for icon only buttons
        style: !hasChildren ? { width: '40px', padding: 0 } : undefined }, props),
        props.icon ? props.icon : null,
        hasChildren && props.icon ? (react_1.default.createElement("div", { style: { width: '8px', display: 'inline-block' } })) : null,
        react_1.default.createElement(TextContainer, { textTransform: props.textTransform || 'sentenceCase' }, props.children)));
};
exports.Button = Button;
exports.Button.defaultProps = {
    color: 'blue',
    disabled: false,
    hasDropShadow: false,
    height: '40px',
    isRounded: false,
    buttonStyle: 'solid',
    width: 'auto',
    textTransform: 'sentenceCase',
};
//# sourceMappingURL=Button.js.map